import { Link } from "react-router-dom";
import { CalendarHeart } from "lucide-react";

export const SubpageHeader = () => (
  <header data-testid="subpage-header" className="sticky top-0 z-50 border-b border-ink/10 bg-sand/85 backdrop-blur-xl">
    <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-4 sm:px-8 lg:px-16">
      <Link to="/" data-testid="subpage-logo" className="flex items-center gap-2.5">
        <img src="/assets/logo-circle.png" alt="The Birth Life logo" className="h-10 w-10 rounded-full border border-ink/10 object-cover" />
        <span className="font-display text-2xl font-semibold tracking-tight text-ink">
          The Birth <span className="italic text-terra">Life</span>
        </span>
      </Link>
      <nav className="flex items-center gap-6">
        <Link data-testid="subpage-nav-blog" to="/blog" className="hidden font-outfit text-sm font-medium text-plumsoft transition-colors hover:text-terra sm:block">
          Blog
        </Link>
        <a data-testid="subpage-nav-services" href="/#services" className="hidden font-outfit text-sm font-medium text-plumsoft transition-colors hover:text-terra sm:block">
          Services
        </a>
        <Link
          data-testid="subpage-book-cta"
          to="/"
          className="inline-flex items-center gap-2 rounded-full bg-ink px-5 py-2.5 font-outfit text-sm font-semibold text-sand transition-colors hover:bg-terra"
        >
          <CalendarHeart className="h-4 w-4" /> Book Consultation
        </Link>
      </nav>
    </div>
  </header>
);
